'use client'

import { useNavigate } from 'react-router-dom'
import { noop } from 'lodash'

import { INBOX_URL } from '@marketplace-web/messaging/conversation-messaging-data'
// TODO: will be handled as part of `ConversationContent` & `ConversationHeader` refactor
// eslint-disable-next-line eslint-comments/no-restricted-disable
// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  ConversationHeader,
  ConversationContent,
} from '@marketplace-web/messaging/conversation-messaging-feature'

const BrazeConversation = () => {
  const navigate = useNavigate()

  const handleGoBack = () => navigate(INBOX_URL)

  return (
    <div className="thread__wrapper">
      <div className="thread__messages-container">
        <ConversationHeader
          oppositeUser={null}
          onInfoIconClick={noop}
          onGoBack={handleGoBack}
          onUsernameClick={noop}
          isSystem
        />
        <div className="thread__messages-wrapper">
          <div className="thread__messages-main">
            <ConversationContent />
          </div>
        </div>
      </div>
    </div>
  )
}

export default BrazeConversation
